"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Loading_1 = __importDefault(require("../../animations/Loading"));
var Error_1 = __importDefault(require("../../illustrations/Error"));
var styles_1 = require("./styles");
function FallbackScreen(_a) {
    var type = _a.type, color = _a.color, message = _a.message;
    return (react_1.default.createElement(styles_1.MainContainer, null,
        react_1.default.createElement(styles_1.ContentContainer, null,
            type === "loading" ? (react_1.default.createElement(Loading_1.default, { color: color })) : type === "error" ? (react_1.default.createElement(Error_1.default, { color: color })) : null,
            message &&
                (typeof message === "string" ? react_1.default.createElement(styles_1.Header, null, message) : message))));
}
exports.default = FallbackScreen;
//# sourceMappingURL=index.js.map